var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
export var GridItemEvent;
(function (GridItemEvent) {
    GridItemEvent["Clicked"] = "Clicked";
    GridItemEvent["Hold"] = "Hold";
})(GridItemEvent || (GridItemEvent = {}));
var GridItem = (function (_super) {
    __extends(GridItem, _super);
    function GridItem(scene, id, position) {
        var _this = this;
        var _a, _b;
        _this = _super.call(this, scene, (_a = position === null || position === void 0 ? void 0 : position.x) !== null && _a !== void 0 ? _a : 0, (_b = position === null || position === void 0 ? void 0 : position.y) !== null && _b !== void 0 ? _b : 0) || this;
        _this.id = id;
        _this.lastDragValueX = 0;
        _this.lastDragValueY = 0;
        _this.isBeingDragged = false;
        _this.pointerWasDownOnThisItem = false;
        _this.holdTimeout = undefined;
        _this.scene.add.existing(_this);
        return _this;
    }
    GridItem.getDimensions = function () {
    };
    GridItem.prototype.getContentData = function () {
    };
    GridItem.prototype.getId = function () { return this.id; };
    GridItem.prototype.handleDrag = function (dragX, dragY) {
        this.isBeingDragged = true;
        this.emit('dragX', this.lastDragValueX - dragX);
        this.emit('dragY', this.lastDragValueY - dragY);
        this.lastDragValueX = dragX;
        this.lastDragValueY = dragY;
    };
    GridItem.prototype.bindEventHandlers = function () {
        var _this = this;
        this.on('pointerdown', function () {
            _this.pointerWasDownOnThisItem = true;
            _this.holdTimeout = window.setTimeout(function () {
                _this.emit(GridItemEvent.Hold);
            }, GridItem.TIME_FOR_HOLD);
        });
        this.on('pointerout', function () {
            _this.pointerWasDownOnThisItem = false;
        });
        this.on('pointerup', function () {
            _this.clearHoldTimeout();
            if (_this.isBeingDragged || !_this.pointerWasDownOnThisItem) {
                return;
            }
            _this.pointerWasDownOnThisItem = false;
            _this.emit(GridItemEvent.Clicked);
        });
        this.on('drag', function (pointer, dragX, dragY) {
            _this.clearHoldTimeout();
            _this.handleDrag(dragX - _this.x, dragY - _this.y);
        });
        this.on('dragend', function () {
            window.setTimeout(function () { _this.isBeingDragged = false; });
            _this.lastDragValueX = 0;
            _this.lastDragValueY = 0;
        });
    };
    GridItem.prototype.clearHoldTimeout = function () {
        if (this.holdTimeout) {
            window.clearTimeout(this.holdTimeout);
            this.holdTimeout = undefined;
        }
    };
    GridItem.TIME_FOR_HOLD = 1000;
    return GridItem;
}(Phaser.GameObjects.Container));
export { GridItem };
